import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { debugStorage } from './utils/debugStorage';
import { testLoginStorage } from './utils/testLoginStorage';

// Enable storage monitoring in development
if (process.env.NODE_ENV === 'development') {
  debugStorage.monitorStorageChanges();
  debugStorage.testTokenStorage();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register Service Worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        
        // Check for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                
                // Dispatch a custom event that the PWAStatus component can listen to
                window.dispatchEvent(new CustomEvent('swUpdateAvailable', {
                  detail: { registration }
                }));
              }
            });
          }
        });
        
        // Listen for messages from the service worker
        navigator.serviceWorker.addEventListener('message', (event) => {
          if (event.data && event.data.type === 'SW_UPDATED') {
          }
        });
      })
      .catch((registrationError) => {
      });
  });
} else {
}

reportWebVitals();